export default {
  packingListItems: [],
  packingListItem: undefined,
};
